import axios, { Axios, AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios'
import { redirect } from 'react-router-dom'

axios.defaults.headers.common['Content-Type'] = 'application/json'
axios.defaults.headers.common['Accept'] = 'application/json'
let _client = new Axios()
export default class AxiosClientProvider {
    constructor(options: AxiosRequestConfig) {
        _client = axios.create(options)
        _client.interceptors.request.use((request: any) => {
            request.headers = { Authorization: `Bearer ${localStorage.getItem('access_token')}` }
            return request
        })
        _client.interceptors.response.use(
            (response: AxiosResponse) => {
                return response
            },
            (error: AxiosError) => {
                if (error.response && error.response.status === 400) {
                    return error.response.data
                }
                if (error.response && error.response.status === 403) {
                    throw error
                }
                if (error.response && error.response.status > 400 && error.response.status < 404) {
                    localStorage.removeItem('access_token')
                    redirect((window.location.href = '/oauth/logout'))
                }
                throw error
            },
        )
    }

    getClient() {
        return _client
    }
}
